import httpService from "@/https/request";
const API = {
  REGISTER: "/login/register",
  ACCOUNT: "/login/account",
  GET_LOGIN_CODE: "/login/getLoginCode",
  SMS_LOGIN: "/login/smsLogin",
  SMS_REGISTER: "/login/smsRegister",
  GET_REGISTER_CODE: "/login/getRegisterCode",
  LOGOUT: "/login/logout"
};

// 注册
export function register(data) {
  return httpService.post(API.REGISTER, data);
}

// 密码登录
export function account(data) {
  return httpService.post(API.ACCOUNT, data);
}

// 获取登录验证码
export function getLoginCode(data) {
  return httpService.post(API.GET_LOGIN_CODE, data);
}
// 手机验证码登录
export function smsLogin(data) {
  return httpService.post(API.SMS_LOGIN, data);
}

// 手机验证码注册
export function smsRegister(data) {
  return httpService.post(API.SMS_REGISTER, data);
}

// 获取注册验证码
export function getRegisterCode(data) {
  return httpService.post(API.GET_REGISTER_CODE, data);
}

// 退出登录
export function logout(data) {
  return httpService.post(API.LOGOUT, data);
}